// extracted by mini-css-extract-plugin
module.exports = {"profile-headline":"profileHeadline-m__profile-headline__2gGzu","title":"profileHeadline-m__title__vF8GN","icon":"profileHeadline-m__icon__2HmVZ"};